import { useEffect, useState } from "react";
import "./MyStyles/watchoDownloadLp.scss";
import { Banner } from './Components/Banner/Banner';
import { UltimateDestination } from './Components/UltimateDestination/UltimateDestination';
import { WatchoServices } from './Components/WatchoServices/WatchoServices';
import { DownloadApp } from './Components/DownloadApp/DownloadApp';
import { Footer } from './Components/Footer/Footer';



export const WatchoDownload = () => {
    const [showQRCode, setShowQRCode] = useState(false);

    
    const useDetectOS = () => {
        const [os, setOS] = useState("Web");
    
        useEffect(() => {
            const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
        
                if (/android/i.test(userAgent)) {
                setOS("Android");
                } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                setOS("iOS");
                } else {
                setOS("Web");
                }
            }, []);
        
            return os;
        };
        const os = useDetectOS();

    useEffect(() => {
        // console.log(showQRCode);
    },[showQRCode])

    return (
        <>
            <Banner setQr={setShowQRCode} os={os} />
            <UltimateDestination setQr={setShowQRCode} os={os}/>
            <WatchoServices setQr={setShowQRCode} os={os}/>
            <DownloadApp setQr={setShowQRCode} os={os}/>
            <Footer />
            {/* QR MODAL */}
            {showQRCode &&
                <div className="watchoDownloadModal">
                <div className="backdrop"></div> 
                <div className="modal show" id="showQRModal" role="dialog" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content-center">
                            <button type="button" className="close" onClick={() => {setShowQRCode(false)}}>
                                <img src="../images/WatchoDownloadLP/close.png" alt='' />
                            </button>
                            <div className="watchoDownloadQRContainer">
                                <h5>Scan QR Code to Install App</h5>
                                <p className="paragraph">Point your camera at the QR code to install Watcho App</p>
                                <div className="qrCode">
                                <img src="../Images/WatchoDownloadLP/qr.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            }
            
        </>
    );
}